import {AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";
import {PathwayConstants} from "../pathway/pathway.constants";

export const CourseNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const name = control.get('name').value;
    const courseId = control.get('course').value;

    const nameIsRequired = courseId.length && courseId[0] == PathwayConstants.non_k12_course;

    return nameIsRequired && !name ? {courseNameRequired: true} : null;
};


export const DuplicatedCourseValidator: ValidatorFn = (form: FormArray): ValidationErrors | null => {
    const list = form.controls;
    const foundElems = [];
    let duplicatedCourse;

    for (let i = 0; i < list.length; i++) {
        if (list[i].value.course[0] && list[i].value.course[0] !== PathwayConstants.non_k12_course) {
            for (let j = 0; j < list.length; j++) {
                if (list[j].value.course[0] && list[i].value.course[0] !== PathwayConstants.non_k12_course && list[i].value.course[0].courseId === list[j].value.course[0].courseId) {
                    if (foundElems.includes(list[j].value.course[0].courseId)) {
                        duplicatedCourse = true;
                    } else {
                        foundElems.push(list[i].value.course[0].courseId);
                    }
                    break;
                }
            }
            if (duplicatedCourse) {
                break;
            }
        }
    }

    return duplicatedCourse ? {duplicatedCourse: true} : null;
};


export const DuplicatedNonK12CourseValidator: ValidatorFn = (form: FormArray): ValidationErrors | null => {
    const list = form.controls;
    const foundElems = [];
    let duplicatedCourse;

    for (let i = 0; i < list.length; i++) {
        if (list[i].value.course[0] === PathwayConstants.non_k12_course && list[i].value.name) {
            for (let j = 0; j < list.length; j++) {
                if (list[j].value.name && list[j].value.course[0] === PathwayConstants.non_k12_course && list[i]?.value.name === list[j]?.value.name) {
                    if (foundElems.includes(list[j].value.name)) {
                        duplicatedCourse = true;
                    } else {
                        foundElems.push(list[i].value.name);
                    }
                    break;
                }
            }
            if (duplicatedCourse) {
                break;
            }
        }
    }

    return duplicatedCourse ? {duplicatedNonK12Course: true} : null;
};
